<template>
  <van-popup
    v-model:show="popupVisible"
    position="top"
    :overlay-style="{ backgroundColor: '#00000088' }"
    :style="{ background: '#ffffff00' }"
  >
    <div class="flex justify-end px-2 py-4">
      <img
        class="w-60"
        src="@/assets/images/open-app-arrow.png"
        alt="点击右上角菜单按钮，选择在浏览器中打开"
      />
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { useChannelStore } from '@/stores'

const channelStore = useChannelStore()
const popupVisible = computed({
  get: () => channelStore.arrowPopupVisible,
  set: (val) => {
    if (val) {
      channelStore.showArrowPopup()
    } else {
      channelStore.hideArrowPopup()
    }
  },
})
</script>
